import { useCallback, useEffect, useState } from "react";
import styles from "./Avatar.module.scss";
import { Bible } from "./Bible/Bible";
import NewVoice from "./NewVoice/NewVoice";
import { changeFormData } from "../../../../redux/slices/formSlice";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../../../redux/store";
import { AvatarSelection } from "./AvatarSelection/AvatarSelection";
import { trackAvatarCreationFromPopup } from "../../../../utils/analyticsTracker";
import { useTranslation } from "react-i18next";
import { useMetrikaLoaded } from "../../../../utils/hooks";

interface Props {
	handleSaveForm: () => void;
	getBrainId: (prompt?: string) => void;
};

const Avatar: React.FC<Props> = ({ handleSaveForm, getBrainId }) => {
	const { t } = useTranslation('form');
	const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(false);
	const [promptText, setPromptText] = useState<string>("");
	const dispatch = useDispatch();
	const shouldTrackActivity = localStorage.getItem("isUserFromPopup") === "true";
	const [userActivity, setUserActivity] = useState<boolean>(false);
	const isLoadedMetrika = useMetrikaLoaded();

	const handleSavePrompt = () => {
		if (isSaveDisabled) return;
		dispatch(changeFormData({ prompt: promptText }));
		getBrainId(promptText);
		handleSaveForm();
	};

	useEffect(() => {
		if (userActivity && shouldTrackActivity && isLoadedMetrika) {
			trackAvatarCreationFromPopup();
		}
	}, [userActivity, shouldTrackActivity, isLoadedMetrika]);

	const handleUserInteraction = useCallback(() => {
		setUserActivity(true);
	}, []);

	return (
		<div className={styles.avatarContainer} onClick={handleUserInteraction}>
			<AvatarSelection />
			<NewVoice handleUserInteraction={handleUserInteraction}/>
			<Bible setIsSaveDisabled={setIsSaveDisabled} setPromptText={setPromptText} />
			<button className={`${styles.saveButton}`} onClick={handleSavePrompt} disabled={isSaveDisabled}>
				{t("save")}
			</button>
		</div>
	);
};

export default Avatar;
